import React, { PropTypes } from 'react/addons';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import PureComponent from 'components/PureComponent';
import setViewport from 'components/setViewport';
import checkMobile from 'utils/checkMobile';
import loadImages from 'utils/loadImages';
import assign from 'object.assign';

const { CSSTransitionGroup } = React.addons;

import bottle_img from './bottle.png';
import label from './label.png';

class Bottle extends PureComponent {
  static propTypes = {
    index: PropTypes.number,
    cover: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired
  };

  static contextTypes = {
    deviceType: PropTypes.string
  };

  static defaultProps = {
    left: '50%'
  };

  constructor() {
    super();
    this.state = { visible: false };
  }

  componentWillMount() {
    if (canUseDOM) {
      loadImages([bottle_img, label, this.props.cover]).then(() => {
        this.setState({ visible: true });
      });
    }
  }

  render() {
    require('./Bottle.styl');
    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);
    const coverStyle = {
      backgroundImage: `url(${this.props.cover})`
    };
    const style = assign(
      {
        opacity: this.state.visible ? 1 : 0
      },
      isMobile ? {} : { left: this.props.left }
    );

    return (
      <div
        className={`Bottle Bottle--${isMobile ? 'mobile' : 'desktop'}`}
        style={style}
      >
        {isMobile
          ? [
              <img
                key="bottle"
                className="Bottle__img"
                src={bottle_img}
                width="185"
                height="481"
              />,
              <img
                key="label"
                className="Bottle__label"
                src={label}
                height="245px"
              />
            ]
          : [
              <img
                key="bottle"
                className="Bottle__img"
                src={bottle_img}
                height="650"
              />,
              <img
                key="label"
                className="Bottle__label"
                src={label}
                height="337"
              />
            ]}

        <CSSTransitionGroup
          transitionName="t-flyout"
          component="div"
          className="Bottle__cover"
          transitionEnter={this.props.showLabel}
        >
          <div
            className="Bottle__cover-img"
            style={coverStyle}
            key={`${this.props.cover}`}
          />
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default setViewport(Bottle);



// WEBPACK FOOTER //
// ./src/components/Bottle/Bottle.js